import Typography from "@mui/material/Typography";

export default function Label(props) {
  return <Typography {...props}>{props.children}</Typography>
}
